var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/components/MediaVideoList/MediaVideoList.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/components/MediaVideoList/MediaVideoList.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n\n";
var macro_t_4 = runtime.makeMacro(
[], 
["data"], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("data", Object.prototype.hasOwnProperty.call(kwargs, "data") ? kwargs["data"] : {});var t_5 = "";t_5 += "\n    <div class=\"MediaVideoList\">\n        <div class=\"MediaVideoList-categories\">\n            <a href=\"";
t_5 += runtime.suppressValue((lineno = 5, colno = 25, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["front:media"])), env.opts.autoescape);
t_5 += "\" class=\"MediaVideoList-category MediaVideoList-category--active\" data-idcat=\"0\">\n                All videos\n            </a>\n            ";
frame = frame.push();
var t_8 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"categories");
if(t_8) {t_8 = runtime.fromIterator(t_8);
var t_7 = t_8.length;
for(var t_6=0; t_6 < t_8.length; t_6++) {
var t_9 = t_8[t_6];
frame.set("cat", t_9);
frame.set("loop.index", t_6 + 1);
frame.set("loop.index0", t_6);
frame.set("loop.revindex", t_7 - t_6);
frame.set("loop.revindex0", t_7 - t_6 - 1);
frame.set("loop.first", t_6 === 0);
frame.set("loop.last", t_6 === t_7 - 1);
frame.set("loop.length", t_7);
t_5 += "\n                <a href=\"#";
t_5 += runtime.suppressValue(runtime.memberLookup((t_9),"slug"), env.opts.autoescape);
t_5 += "\" class=\"MediaVideoList-category\" data-idcat=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((t_9),"id"), env.opts.autoescape);
t_5 += "\">\n                    ";
t_5 += runtime.suppressValue(runtime.memberLookup((t_9),"title"), env.opts.autoescape);
t_5 += "\n                </a>\n            ";
;
}
}
frame = frame.pop();
t_5 += "\n        </div>\n\n        <div class=\"MediaVideoList-dropdown\">\n            <div class=\"MediaVideoList-dropdownTitle\">All videos</div>\n            <div class=\"MediaVideoList-dropdownArrow\"></div>\n\n            <div class=\"MediaVideoList-dropdownPanel\">\n                <a href=\"";
t_5 += runtime.suppressValue((lineno = 20, colno = 29, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["front:media"])), env.opts.autoescape);
t_5 += "\" class=\"MediaVideoList-dropdownCategory MediaVideoList-dropdownCategory--active\" data-idcat=\"0\">\n                    All videos\n                </a>\n                ";
frame = frame.push();
var t_12 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"categories");
if(t_12) {t_12 = runtime.fromIterator(t_12);
var t_11 = t_12.length;
for(var t_10=0; t_10 < t_12.length; t_10++) {
var t_13 = t_12[t_10];
frame.set("cat", t_13);
frame.set("loop.index", t_10 + 1);
frame.set("loop.index0", t_10);
frame.set("loop.revindex", t_11 - t_10);
frame.set("loop.revindex0", t_11 - t_10 - 1);
frame.set("loop.first", t_10 === 0);
frame.set("loop.last", t_10 === t_11 - 1);
frame.set("loop.length", t_11);
t_5 += "\n                    <a href=\"#";
t_5 += runtime.suppressValue(runtime.memberLookup((t_13),"slug"), env.opts.autoescape);
t_5 += "\" class=\"MediaVideoList-dropdownCategory\" data-idcat=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((t_13),"id"), env.opts.autoescape);
t_5 += "\">\n                        ";
t_5 += runtime.suppressValue(runtime.memberLookup((t_13),"title"), env.opts.autoescape);
t_5 += "\n                    </a>\n                ";
;
}
}
frame = frame.pop();
t_5 += "\n            </div>\n        </div>\n\n        <div class=\"MediaVideoList-list\">\n            <ul class=\"MediaVideoList-list-videos active\" data-idcat=\"0\">\n                ";
t_5 += runtime.suppressValue((lineno = 33, colno = 45, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "macros")),"includeComponent"), "macros[\"includeComponent\"]", context, ["front/components/MediaVideoList/MediaVideoListInner.jinja",runtime.makeKeywordArgs({"data": {"list": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"list"),"isInitial": 1},"caller": (function (){var macro_t_14 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_15 = "";;
frame = frame.pop();
return new runtime.SafeString(t_15);
});
return macro_t_14;})()})])), env.opts.autoescape);
t_5 += "\n            </ul>\n\n            ";
frame = frame.push();
var t_18 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"categories");
if(t_18) {t_18 = runtime.fromIterator(t_18);
var t_17 = t_18.length;
for(var t_16=0; t_16 < t_18.length; t_16++) {
var t_19 = t_18[t_16];
frame.set("cat", t_19);
frame.set("loop.index", t_16 + 1);
frame.set("loop.index0", t_16);
frame.set("loop.revindex", t_17 - t_16);
frame.set("loop.revindex0", t_17 - t_16 - 1);
frame.set("loop.first", t_16 === 0);
frame.set("loop.last", t_16 === t_17 - 1);
frame.set("loop.length", t_17);
t_5 += "\n                <ul class=\"MediaVideoList-list-videos\" data-idcat=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((t_19),"id"), env.opts.autoescape);
t_5 += "\">\n                </ul>\n            ";
;
}
}
frame = frame.pop();
t_5 += "\n\n            <div class=\"MediaVideoList-btnMore-outer\">\n                <div class=\"MediaVideoList-btnMore\" ";
if(!runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"hasMore")) {
t_5 += "style=\"display:none\"";
;
}
t_5 += ">Show more</div>\n            </div>\n        </div>\n    </div>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_5);
});
context.addExport("MediaVideoList");
context.setVariable("MediaVideoList", macro_t_4);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/components/MediaVideoList/MediaVideoList.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/MediaVideoList/MediaVideoList.jinja
// module id = 499
// module chunks = 0